import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppContext } from '../../context/context';
import {
  AdminGetRooms,
  AdminUploadImages,
} from '../../redux/admin/admin_room/roomsServiceSync';
import {
  updateCurrentRoom,
  updateMessage,
  updateRoom,
  updateRoomMessageDetails,
  updateSelectedRoom,
} from '../../redux/admin/admin_room/roomSlice';
import useImageDownloader from '../../utils/useImageDownloader';
import CurrencyFormatter from '../../component/CurrencyFormatter';
import moment from 'moment';
import { InfinitySpin } from 'react-loader-spinner';
import {
  SelectionPaymentOrder,
  SelectionSingleOrder,
} from '../../utils/orderSelection';
import Select from 'react-select';
import ScrollToBottom from 'react-scroll-to-bottom';
import { PhotoView } from 'react-photo-view';

const Chat = () => {
  const dispatch = useDispatch();

  const [typedMessage, setTypedMessage] = useState('');

  const [uploadImages, setUploadImages] = useState({ length: 0 });

  const [searchRoom, setSearchRoom] = useState([]);

  const [search, setSearch] = useState('');

  const { socket } = useContext(AppContext);

  const { profile } = useSelector((state) => state.profile);

  const {
    rooms,
    current_room,
    messages,
    selectedRoom,
    roomImageLoader,
    roomImageDetails,
  } = useSelector((state) => state.admin_room);

  const { my_single_order_status, my_single_payment_status } = useSelector(
    (state) => state.admin_order
  );

  useEffect(() => {
    dispatch(AdminGetRooms());

    socket.emit('new-user');

    return () => {
      dispatch(updateRoom([]));

      dispatch(updateMessage(null));

      dispatch(updateCurrentRoom(''));

      dispatch(updateSelectedRoom({}));
    };
  }, []);

  socket.off('new-users').on('new-users', (payload) => {
    dispatch(updateRoom(payload));
  });

  socket.off('room-messages').on('room-messages', (roomMessages) => {
    dispatch(updateMessage(roomMessages));
  });

  const JoinRoom = (room, currentRoom, isPublic = true) => {
    if (!profile) {
      return alert('please login');
    }

    socket.emit('admin-join-room', room.room, currentRoom, room);

    dispatch(updateCurrentRoom(room.room));

    dispatch(updateSelectedRoom(room));
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setTypedMessage(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!typedMessage) return;

    let today = new Date();

    const minutes =
      today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes();

    const time = today.getHours() + ':' + minutes;

    const roomId = current_room;

    if (uploadImages.length === 0) {
      socket.emit(
        'admin-message-room',
        roomId,
        typedMessage,
        profile,
        time,
        today.toISOString().split('T')[0],
        false,
        []
      );
    } else {
      const ImageDetails = roomImageDetails?.map((item) => {
        return {
          pic_url: item?.secure_url,
          pic_id: item?.public_id,
        };
      });

      socket.emit(
        'admin-message-room',
        roomId,
        typedMessage,
        profile,
        time,
        today.toISOString().split('T')[0],
        true,
        ImageDetails
      );

      setUploadImages({ length: 0 });
    }

    setTypedMessage('');

    dispatch(updateRoomMessageDetails([]));
  };

  const handleSearchUser = (e) => {
    const { value } = e.target;
    setSearch(value);

    if (value) {
      const searchForRoom = rooms?.filter((item) =>
        item?.name?.toLowerCase().includes(value?.toLowerCase())
      );

      setSearchRoom(searchForRoom);
    } else {
      setSearchRoom([]);
    }
  };

  const handleUploadImage = async (e) => {
    const image = e.target.files;

    if (image) {
      const formData = new FormData();

      Array.from(image).forEach((file, i) => {
        formData.append(`file`, file);
      });

      await dispatch(AdminUploadImages(formData));

      setUploadImages(image);
    }
  };

  useEffect(() => {
    if (roomImageDetails?.length > 0) {
      roomImageDetails.forEach((file, i) => {
        setTypedMessage((value) => value + ' ' + file?.secure_url);
      });
    }
  }, [roomImageDetails]);

  const { downloadImage } = useImageDownloader();

  const handleChangeSelectionStatus = (selectedOption) => {
    socket.emit(
      'update_selection_state',
      selectedOption?.value,
      selectedRoom.room
    );
  };

  const handleChangePaymentStatus = (selectedOption) => {
    socket.emit(
      'update_payment_state',
      selectedOption?.value,
      selectedRoom.room
    );
  };

  console.log(current_room, 'current_room');

  return (
    <>
      <div class="row g-1">
        <div class="col-xxl-3">
          <div
            class="h-100"
            tabindex="-1"
            id="Contactoffcanvas"
            aria-labelledby="ContactoffcanvasLabel"
          >
            <div class="card position-relative overflow-hidden">
              <div class="card-header border-0 d-flex justify-content-between align-items-center">
                <h4 class="card-title">Chat</h4>
                <a
                  href="#user-setting"
                  class="fs-18"
                  type="button"
                  data-bs-toggle="offcanvas"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  <i class="bx bx-cog"></i>
                </a>
              </div>

              <form class="chat-search px-3">
                <div class="chat-search-box">
                  <input
                    value={search || ''}
                    class="form-control"
                    type="text"
                    name="search"
                    placeholder="Search ..."
                    onChange={handleSearchUser}
                  />

                  <button
                    type="submit"
                    class="btn btn-sm btn-link search-icon p-0"
                  >
                    <i class="bx bx-search-alt"></i>
                  </button>
                </div>
              </form>

              <div class="tab-content">
                <div class="tab-pane show active" id="chat-list">
                  <div
                    class="px-3 mb-3 chat-setting-height flex flex-col gap-2"
                    data-simplebar
                  >
                    {search !== '' && search !== null && search !== undefined
                      ? searchRoom?.map((item, key) => (
                          <a
                            key={key}
                            // href="javascript:void(0);"
                            class="text-body"
                            style={{ width: '100%' }}
                            onClick={() => JoinRoom(item)}
                          >
                            <div
                              class={`d-flex align-items-center p-2 ${
                                item?.room === current_room
                                  ? 'bg-light bg-opacity-50 rounded-1'
                                  : ''
                              }`}
                              style={{ width: '100%' }}
                            >
                              <div class="flex-shrink-0 position-relative">
                                <img
                                  src={`/assets/img/avatar-profile-photo.png`}
                                  class="me-2 rounded-circle"
                                  height="36"
                                  alt="avatar-2"
                                  style={{ height: '36px', width: '36px' }}
                                />
                              </div>
                              <div class="flex-grow-1 overflow-hidden">
                                <h5 class="my-0">{item?.order_title}</h5>
                                <p class="mt-1 mb-0 fs-13 text-muted d-flex align-items-end justify-content-between">
                                  <span class="w-75">
                                    {moment(item?.lastTime).format(
                                      'hh:mm:ss a'
                                    )}
                                  </span>

                                  <span
                                    class={`badge border ${
                                      item?.product_status === 'pending'
                                        ? 'border-secondary text-secondary'
                                        : item?.product_status === 'processing'
                                        ? 'border-warning text-warning'
                                        : item?.product_status === 'cancelled'
                                        ? 'border-danger text-danger'
                                        : 'border-success text-success'
                                    } px-2 fs-13 capitalize`}
                                  >
                                    {item?.product_status}
                                  </span>
                                </p>

                                <p class="mt-1 mb-0 fs-13 text-muted d-flex align-items-end justify-content-between">
                                  {item?.notification > 0 && (
                                    <span class="text-red-600">
                                      {item?.notification}
                                    </span>
                                  )}
                                </p>
                              </div>
                            </div>
                          </a>
                        ))
                      : rooms?.length > 0 &&
                        rooms?.map((item, key) => (
                          <a
                            key={key}
                            href="javascript:void(0);"
                            class="text-body"
                            style={{ width: '100%' }}
                            onClick={() => JoinRoom(item)}
                          >
                            <div
                              class={`d-flex align-items-center p-2 ${
                                item?.room === current_room
                                  ? 'bg-light bg-opacity-50 rounded-1'
                                  : ''
                              }`}
                              style={{ width: '100%' }}
                            >
                              <div class="flex-shrink-0 position-relative">
                                <img
                                  src={`/assets/img/avatar-profile-photo.png`}
                                  class="me-2 rounded-circle"
                                  height="36"
                                  alt="avatar-2"
                                  style={{ height: '36px', width: '36px' }}
                                />
                              </div>
                              <div class="flex-grow-1 overflow-hidden">
                                <h5 class="my-0">{item?.order_title}</h5>

                                <p class="mt-1 mb-0 fs-13 text-muted d-flex align-items-end justify-content-between">
                                  <span class="w-75">
                                    {moment(item?.lastTime).format(
                                      'hh:mm:ss a'
                                    )}
                                  </span>
                                  {/* <i class="bx bx-check-double text-success"></i> */}

                                  <span
                                    class={`badge border ${
                                      item?.product_status === 'pending'
                                        ? 'border-secondary text-secondary'
                                        : item?.product_status === 'processing'
                                        ? 'border-warning text-warning'
                                        : item?.product_status === 'cancelled'
                                        ? 'border-danger text-danger'
                                        : 'border-success text-success'
                                    } px-2 fs-13 capitalize`}
                                  >
                                    {item?.product_status}
                                  </span>
                                </p>

                                <p class="mt-1 mb-0 fs-13 text-muted d-flex align-items-end justify-content-between">
                                  {item?.notification > 0 && (
                                    <span class="text-red-600">
                                      {item?.notification}
                                    </span>
                                  )}
                                </p>
                              </div>
                            </div>
                          </a>
                        ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xxl-9">
          <div class="card position-relative overflow-hidden">
            {current_room && (
              <>
                <div class="card-header d-flex align-items-center mh-100">
                  {/* <button
                    class="btn btn-light d-xxl-none d-flex align-items-center px-2 me-2"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#Contactoffcanvas"
                    aria-controls="Contactoffcanvas"
                  >
                    <i class="bx bx-menu fs-18"></i>
                  </button> */}

                  <div class="d-flex align-items-center">
                    <img
                      src={`/assets/img/avatar-profile-photo.png`}
                      class="me-2 rounded"
                      height="36"
                      alt="avatar-4"
                      style={{ height: '36px', width: '36px' }}
                    />
                    <div class="d-none d-md-flex flex-column">
                      <h5 class="my-0 fs-16 fw-semibold">
                        <a
                          data-bs-toggle="offcanvas"
                          href="#user-profile"
                          class="text-dark"
                        >
                          {selectedRoom?.order_title}
                        </a>
                      </h5>
                      {/* <p class="mb-0 text-success fw-semibold fst-italic">
                        typing...
                      </p> */}
                    </div>
                  </div>

                  <div class="flex-grow-1">
                    <ul class="list-inline float-end d-flex gap-3 mb-0">
                      <li style={{ maxWidth: '100px' }}>
                        <p>Select Payment</p>
                        <Select
                          defaultValue={my_single_payment_status}
                          onChange={handleChangePaymentStatus}
                          options={SelectionPaymentOrder}
                        />
                      </li>
                      <li style={{ maxWidth: '100px' }}>
                        <p>Select Status</p>
                        <Select
                          defaultValue={my_single_order_status}
                          onChange={handleChangeSelectionStatus}
                          options={SelectionSingleOrder}
                        />
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="chat-box">
                  <ScrollToBottom scrollViewClassName="chat-conversation-list p-3 chatbox-height h-[40%] overflow-y-auto">
                    {messages?.map((item, key) => (
                      <Fragment key={key}>
                        <li className="chat-date mt-0 flex items-center justify-center">
                          <span>{item?._id}</span>
                        </li>

                        {item?.messagesByDate?.map((data, ind) => (
                          <Fragment key={ind}>
                            {data?.from?._id !== profile?._id ? (
                              <>
                                {data?.image === true ? (
                                  <li class="clearfix">
                                    <div class="chat-conversation-text ms-0">
                                      <div class="d-flex">
                                        <div class="chat-ctext-wrap">
                                          {data?.imageDetails?.map(
                                            (image, i) => (
                                              <PhotoView
                                                src={
                                                  image?.pic_url ||
                                                  '/assets/images/small/img-1.jpg'
                                                }
                                              >
                                                <a href="javascript:void(0);">
                                                  <img
                                                    src={
                                                      image?.pic_url ||
                                                      '/assets/images/small/img-1.jpg'
                                                    }
                                                    alt="attachment"
                                                    style={{ height: '84px' }}
                                                    class="img-thumbnail me-1"
                                                  />
                                                </a>
                                              </PhotoView>
                                            )
                                          )}
                                          {/* <a href="javascript:void(0);">
                                            <img
                                              src="/assets/images/small/img-2.jpg"
                                              alt="attachment"
                                              style={{ height: '84px' }}
                                              class="img-thumbnail me-1"
                                            />
                                          </a>
                                          <a href="javascript:void(0);">
                                            <img
                                              src="/assets/images/small/img-3.jpg"
                                              alt="attachment"
                                              style={{ height: '84px' }}
                                              class="img-thumbnail me-1"
                                            />
                                          </a> */}
                                        </div>
                                      </div>
                                      <p class="text-muted fs-12 mb-0 mt-1 ms-2">
                                        {moment(data?.createdAt).format(
                                          'hh:mm:ss a'
                                        )}
                                      </p>
                                    </div>
                                  </li>
                                ) : data?.product_details ? (
                                  <li class="clearfix">
                                    <div class="chat-conversation-text ms-0">
                                      <div class="d-flex">
                                        <div class="chat-ctext-wrap">
                                          <p>
                                            <div class="card">
                                              <div class="card-header">
                                                <h4 class="card-title">
                                                  Product
                                                </h4>
                                              </div>
                                              <div class="card-body">
                                                <div class="table-responsive">
                                                  <table class="table align-middle mb-0 table-hover table-centered">
                                                    <thead class="bg-light-subtle border-bottom">
                                                      <tr>
                                                        <th>Product Name</th>
                                                        <th>Quantity</th>
                                                        <th>Price</th>
                                                        <th>Total Price</th>
                                                        <th>color</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {data?.products?.map(
                                                        (goods, ins) => (
                                                          <tr key={ins}>
                                                            <td>
                                                              <div class="d-flex align-items-center gap-2">
                                                                <div class="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                                                  <PhotoView
                                                                    src={
                                                                      goods
                                                                        ?.gallery[0]
                                                                        ?.pic_url ||
                                                                      '/assets/images/product/p-1.png'
                                                                    }
                                                                  >
                                                                    <img
                                                                      src={
                                                                        goods
                                                                          ?.gallery[0]
                                                                          ?.pic_url ||
                                                                        '/assets/images/product/p-1.png'
                                                                      }
                                                                      alt=""
                                                                      class="avatar-md"
                                                                    />
                                                                  </PhotoView>
                                                                </div>
                                                              </div>
                                                            </td>

                                                            <td>
                                                              {goods?.quantity}
                                                            </td>
                                                            <td>
                                                              <CurrencyFormatter
                                                                value={
                                                                  goods?.price
                                                                }
                                                                currency={
                                                                  goods?.symbol
                                                                }
                                                              />
                                                            </td>
                                                            <td>
                                                              <CurrencyFormatter
                                                                value={
                                                                  goods?.totalPrice
                                                                }
                                                                currency={
                                                                  goods?.symbol
                                                                }
                                                              />
                                                            </td>
                                                            <td>
                                                              <div
                                                                style={{
                                                                  backgroundColor:
                                                                    goods?.color,
                                                                }}
                                                                className={`w-10 h-10 rounded-full border cursor-pointer`}
                                                              />
                                                            </td>
                                                          </tr>
                                                        )
                                                      )}
                                                      <tr>
                                                        <td>Total Price</td>

                                                        <td>
                                                          <CurrencyFormatter
                                                            value={
                                                              data?.totalPrice
                                                            }
                                                            currency={
                                                              data?.symbol
                                                            }
                                                          />
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </p>
                                        </div>
                                      </div>
                                      <p class="text-muted fs-12 mb-0 mt-1">
                                        {moment(data?.createdAt).format(
                                          'hh:mm:ss a'
                                        )}
                                        <i class="bx bx-check-double ms-1 text-primary"></i>
                                      </p>
                                    </div>
                                  </li>
                                ) : (
                                  <li class="clearfix">
                                    <div class="chat-conversation-text">
                                      <div class="d-flex">
                                        <div class="chat-ctext-wrap">
                                          <p>{data?.content}</p>
                                        </div>
                                      </div>
                                      <p class="text-muted fs-12 mb-0 mt-1 ms-2">
                                        {moment(data?.createdAt).format(
                                          'hh:mm:ss a'
                                        )}
                                      </p>
                                    </div>
                                  </li>
                                )}
                              </>
                            ) : (
                              <>
                                {data?.image === true ? (
                                  <li class="clearfix odd">
                                    <div class="chat-conversation-text ms-0">
                                      <div class="d-flex justify-content-end">
                                        <div class="chat-ctext-wrap">
                                          {data?.imageDetails?.map(
                                            (image, i) => (
                                              <PhotoView
                                                src={
                                                  image?.pic_url ||
                                                  '/assets/images/small/img-1.jpg'
                                                }
                                              >
                                                <a href="javascript:void(0);">
                                                  <img
                                                    src={
                                                      image?.pic_url ||
                                                      '/assets/images/small/img-1.jpg'
                                                    }
                                                    alt="attachment"
                                                    style={{ height: '84px' }}
                                                    class="img-thumbnail me-1"
                                                  />
                                                </a>
                                              </PhotoView>
                                            )
                                          )}
                                          {/* <a href="javascript:void(0);">
                                            <img
                                              src="/assets/images/small/img-2.jpg"
                                              alt="attachment"
                                              style={{ height: '84px' }}
                                              class="img-thumbnail me-1"
                                            />
                                          </a>
                                          <a href="javascript:void(0);">
                                            <img
                                              src="/assets/images/small/img-3.jpg"
                                              alt="attachment"
                                              style={{ height: '84px' }}
                                              class="img-thumbnail me-1"
                                            />
                                          </a> */}
                                        </div>
                                      </div>
                                      <p class="text-muted fs-12 mb-0 mt-1 ms-2">
                                        {moment(data?.createdAt).format(
                                          'hh:mm:ss a'
                                        )}
                                      </p>
                                    </div>
                                  </li>
                                ) : data?.product_details ? (
                                  <li class="clearfix odd">
                                    <div class="chat-conversation-text ms-0">
                                      <div class="d-flex justify-content-end">
                                        <div class="chat-ctext-wrap">
                                          <p>
                                            <div class="card">
                                              <div class="card-header">
                                                <h4 class="card-title">
                                                  Product
                                                </h4>
                                              </div>
                                              <div class="card-body">
                                                <div class="table-responsive">
                                                  <table class="table align-middle mb-0 table-hover table-centered">
                                                    <thead class="bg-light-subtle border-bottom">
                                                      <tr>
                                                        <th>Product Name</th>
                                                        <th>Quantity</th>
                                                        <th>Price</th>
                                                        <th>Total Price</th>
                                                        <th>color</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {data?.products?.map(
                                                        (goods, ins) => (
                                                          <tr key={ins}>
                                                            <td>
                                                              <div class="d-flex align-items-center gap-2">
                                                                <div class="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                                                  <PhotoView
                                                                    src={
                                                                      goods
                                                                        ?.gallery[0]
                                                                        ?.pic_url ||
                                                                      '/assets/images/product/p-1.png'
                                                                    }
                                                                  >
                                                                    <img
                                                                      src={
                                                                        goods
                                                                          ?.gallery[0]
                                                                          ?.pic_url ||
                                                                        '/assets/images/product/p-1.png'
                                                                      }
                                                                      alt=""
                                                                      class="avatar-md"
                                                                    />
                                                                  </PhotoView>
                                                                </div>
                                                              </div>
                                                            </td>

                                                            <td>
                                                              {goods?.quantity}
                                                            </td>
                                                            <td>
                                                              <CurrencyFormatter
                                                                value={
                                                                  goods?.price
                                                                }
                                                                currency={
                                                                  goods?.symbol
                                                                }
                                                              />
                                                            </td>
                                                            <td>
                                                              <CurrencyFormatter
                                                                value={
                                                                  goods?.totalPrice
                                                                }
                                                                currency={
                                                                  goods?.symbol
                                                                }
                                                              />
                                                            </td>
                                                            <td>
                                                              <div
                                                                style={{
                                                                  backgroundColor:
                                                                    goods?.color,
                                                                }}
                                                                className={`w-10 h-10 rounded-full border cursor-pointer`}
                                                              />
                                                            </td>
                                                          </tr>
                                                        )
                                                      )}
                                                      <tr>
                                                        <td>Total Price</td>

                                                        <td>
                                                          <CurrencyFormatter
                                                            value={
                                                              data?.totalPrice
                                                            }
                                                            currency={
                                                              data?.symbol
                                                            }
                                                          />
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </p>
                                        </div>
                                      </div>
                                      <p class="text-muted fs-12 mb-0 mt-1">
                                        {moment(data?.createdAt).format(
                                          'hh:mm:ss a'
                                        )}
                                        <i class="bx bx-check-double ms-1 text-primary"></i>
                                      </p>
                                    </div>
                                  </li>
                                ) : (
                                  <li class="clearfix odd">
                                    <div class="chat-conversation-text ms-0">
                                      <div class="d-flex justify-content-end">
                                        <div class="chat-ctext-wrap">
                                          <p className="text-white">
                                            {data?.content}
                                          </p>
                                        </div>
                                      </div>
                                      <p class="text-muted fs-12 mb-0 mt-1">
                                        {moment(data?.createdAt).format(
                                          'hh:mm:ss a'
                                        )}
                                        <i class="bx bx-check-double ms-1 text-primary"></i>
                                      </p>
                                    </div>
                                  </li>
                                )}
                              </>
                            )}
                          </Fragment>
                        ))}
                      </Fragment>
                    ))}
                  </ScrollToBottom>
                  <div class="bg-light bg-opacity-50 p-2">
                    <form
                      class="needs-validation"
                      name="chat-form"
                      id="chat-form"
                    >
                      <div class="row align-items-center">
                        <div class="col mb-2 mb-sm-0 d-flex">
                          <div class="input-group">
                            <a
                              href="javascript: void(0);"
                              class="btn btn-sm btn-light d-flex align-items-center input-group-text"
                            >
                              <i class="bx bx-smile fs-18"></i>
                            </a>
                            <input
                              type="text"
                              class="form-control border-0"
                              placeholder="Enter your message"
                              value={typedMessage || ''}
                              onChange={handleChange}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  handleSubmit(e);
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div class="col-sm-auto">
                          <div class="">
                            {roomImageLoader ? (
                              <InfinitySpin width="80" color="#ED1D24" />
                            ) : (
                              <div class="btn-group btn-toolbar">
                                <a
                                  href="javascript: void(0);"
                                  class="btn btn-sm btn-light"
                                  style={{ position: 'relative' }}
                                >
                                  <i class="bx bx-paperclip fs-18"></i>

                                  <input
                                    type="file"
                                    multiple
                                    disabled={roomImageLoader}
                                    onChange={handleUploadImage}
                                    style={{
                                      position: 'absolute',
                                      opacity: 0,
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                    }}
                                  />
                                </a>
                                {/* <div className="btn-file btn">
                                <i className="feather-plus" />
                                <input
                                  type="file"
                                  multiple
                                  disabled={roomImageLoader}
                                  onChange={handleUploadImage}
                                />
                              </div> */}
                                {/* <a
                                  href="javascript: void(0);"
                                  class="btn btn-sm btn-light"
                                >
                                  <i class="bx bx-video fs-18"></i>
                                </a> */}
                                <button
                                  type="submit"
                                  class="btn btn-sm btn-primary chat-send"
                                  onClick={handleSubmit}
                                >
                                  <i class="bx bx-send fs-18"></i>
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Chat;
